<template>
   <v-container fluid>
      <p>Base Home</p>
   </v-container>
</template>

<script>
export default {};
</script>
